import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultation-result',
  templateUrl: './consultation-result.component.html',
  styleUrls: ['./consultation-result.component.scss']
})
export class ConsultationResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
